import React__default from 'react';
import classnames from 'classnames';
import { useFramesEcommContext } from './context/FramesEcommContext.js';
import { useProductDetailSlots } from '../../../slots/context.js';
import { ProductTag } from '../components/ProductTag/ProductTag.js';
import { FramesBundleContentDescriptionContainer } from './components/FramesBundleContentDescription/FramesBundleContentDescriptionContainer.js';
import { FramesPriceSection } from './components/FramesPriceSection/FramesPriceSection.js';
import { MultiFacetPicker } from '../components/FacetPickerContainers/MultiFacetPicker/MultiFacetPicker.js';
import { FramesOfferingsList } from './components/FramesOfferingsList/FramesOfferingsList.js';
import { FramesDeliveryIndicator } from './components/FramesDeliveryIndicator/FramesDeliveryIndicator.js';
import { useProductData } from '../../../context/product-context-hooks.js';

const FramesEcommContent = ({ className , cta , ctaRef , reimbursableLogo ,  })=>{
    const { activeVariant: { displayName  } ,  } = useProductData();
    const { handleConfiguratorClose , isConfiguratorOpen  } = useFramesEcommContext();
    const { Slots  } = useProductDetailSlots();
    return /*#__PURE__*/ React__default.createElement("section", {
        "aria-label": displayName,
        className: classnames('frames-ecomm-content', className)
    }, reimbursableLogo, /*#__PURE__*/ React__default.createElement(ProductTag, null), /*#__PURE__*/ React__default.createElement("div", {
        className: "frames-ecomm-content__section"
    }, /*#__PURE__*/ React__default.createElement(FramesBundleContentDescriptionContainer, null), /*#__PURE__*/ React__default.createElement(FramesPriceSection, null)), /*#__PURE__*/ React__default.createElement(MultiFacetPicker, {
        sectionClassName: "frames-ecomm-content__section"
    }), /*#__PURE__*/ React__default.createElement(FramesOfferingsList, null), /*#__PURE__*/ React__default.createElement(FramesDeliveryIndicator, null), /*#__PURE__*/ React__default.createElement("div", {
        ref: ctaRef
    }, cta), Slots.AfterCTA ? /*#__PURE__*/ React__default.createElement(Slots.AfterCTA, null) : null, Slots.Configurator && /*#__PURE__*/ React__default.createElement(Slots.Configurator, {
        id: "glasses",
        onModalClose: handleConfiguratorClose,
        isOpen: isConfiguratorOpen
    }));
};

export { FramesEcommContent };
//# sourceMappingURL=FramesEcommContent.js.map
